import { Call911Warning } from '../../../../components/Call911Warning'

export const call911Page = () => ({
  id: 'call_911_page',
  fields: [
    {
      type: 'content',
      content: Call911Warning
    }
  ],
  action: {
    type: 'next',
    buttonText: 'Acknowledge and continue'
  }
})
